import { getObservableById, setObservableById } from './helper';

export const openedModal$ = new Map();

export const getOpenedModal$ = (compId: string) =>
  getObservableById(openedModal$, compId, '');

export const setOpenedModal$ = (openedModal: string, compId: string) =>
  setObservableById(openedModal$, openedModal, compId);
